import { createAction, handleActions } from "redux-actions";

import { createOmniPaginationObject } from "../../utils/helpers";
import { helperGetIsoDate } from "../../utils/helpers.js";

// actions
const actionScope = "BOTPRESS_SESSION_";

export const botpressSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const setBotpressBotODMRequest = createAction(actionScope + "SET_BOTPRESS_BOT_ODM_REQUEST");
export const setBotpressBotODMSuccess = createAction(actionScope + "SET_BOTPRESS_BOT_ODM_SUCCESS");

export const setAnalyticsBotODMRequest = createAction(
  actionScope + "SET_ANALYTICS_BOT_ODM_REQUEST",
);
export const setAnalyticsBotODMSuccess = createAction(
  actionScope + "SET_ANALYTICS_BOT_ODM_SUCCESS",
);

export const loadBotRequest = createAction(actionScope + "LOAD_BOT_REQUEST");
export const loadBotSuccess = createAction(actionScope + "LOAD_BOT_SUCCESS");

export const loadAnalyticsRequest = createAction(actionScope + "LOAD_ANALYTICS_REQUEST");
export const loadAnalyticsSuccess = createAction(actionScope + "LOAD_ANALYTICS_SUCCESS");

export const loadConfigurationsRequest = createAction(actionScope + "LOAD_CONFIGURATIONS_REQUEST");
export const loadConfigurationsSuccess = createAction(actionScope + "LOAD_CONFIGURATIONS_SUCCESS");

export const loadBotpressSummaryRequest = createAction(
  actionScope + "LOAD_BOTPRESS_SUMMARY_REQUEST",
);
export const loadBotpressSummarySuccess = createAction(
  actionScope + "LOAD_BOTPRESS_SUMMARY_SUCCESS",
);

export const searchChatsRequest = createAction(actionScope + "SEARCH_CHATS_REQUEST");
export const searchChatsSuccess = createAction(actionScope + "SEARCH_CHATS_SUCCESS");

export const setSearchChatsDatesRequest = createAction(
  actionScope + "SET_SEARCH_CHATS_DATES_REQUEST",
);
export const setSearchChatsDatesSuccess = createAction(
  actionScope + "SET_SEARCH_CHATS_DATES_SUCCESS",
);

export const analyzeChatsRequest = createAction(actionScope + "ANALYZE_CHATS_REQUEST");
export const analyzeChatsSuccess = createAction(actionScope + "ANALYZE_CHATS_SUCCESS");

export const deleteChatRequest = createAction(actionScope + "DELETE_CHAT_REQUEST");
export const deleteChatSuccess = createAction(actionScope + "DELETE_CHAT_SUCCESS");

export const updateChatRequest = createAction(actionScope + "UPDATE_CHAT_REQUEST");
export const updateChatSuccess = createAction(actionScope + "UPDATE_CHAT_SUCCESS");

export const searchFlaggedChatsRequest = createAction(actionScope + "SEARCH_FLAGGED_CHATS_REQUEST");
export const searchFlaggedChatsSuccess = createAction(actionScope + "SEARCH_FLAGGED_CHATS_SUCCESS");

export const searchFeedbackRequest = createAction(actionScope + "SEARCH_FEEDBACK_REQUEST");
export const searchFeedbackSuccess = createAction(actionScope + "SEARCH_FEEDBACK_SUCCESS");

export const updateFeedbackRequest = createAction(actionScope + "UPDATE_FEEDBACK_REQUEST");
export const updateFeedbackSuccess = createAction(actionScope + "UPDATE_FEEDBACK_SUCCESS");

export const deleteFeedbackRequest = createAction(actionScope + "DELETE_FEEDBACK_REQUEST");
export const deleteFeedbackSuccess = createAction(actionScope + "DELETE_FEEDBACK_SUCCESS");

export const searchAssessmentRequest = createAction(actionScope + "SEARCH_ASSESSMENT_REQUEST");
export const searchAssessmentSuccess = createAction(actionScope + "SEARCH_ASSESSMENT_SUCCESS");

export const updateAssessmentRequest = createAction(actionScope + "UPDATE_ASSESSMENT_REQUEST");
export const updateAssessmentSuccess = createAction(actionScope + "UPDATE_ASSESSMENT_SUCCESS");

export const deleteAssessmentsRequest = createAction(actionScope + "DELETE_ASSESSMENTS_REQUEST");
export const deleteAssessmentsSuccess = createAction(actionScope + "DELETE_ASSESSMENTS_SUCCESS");

export const searchProductsRequest = createAction(actionScope + "SEARCH_PRODUCTS_REQUEST");
export const searchProductsSuccess = createAction(actionScope + "SEARCH_PRODUCTS_SUCCESS");

export const updateProductRequest = createAction(actionScope + "UPDATE_PRODUCT_REQUEST");
export const updateProductSuccess = createAction(actionScope + "UPDATE_PRODUCT_SUCCESS");

export const deleteProductsRequest = createAction(actionScope + "DELETE_PRODUCTS_REQUEST");
export const deleteProductsSuccess = createAction(actionScope + "DELETE_PRODUCTS_SUCCESS");

export const loadConversationRequest = createAction(actionScope + "LOAD_CONVERSATION_REQUEST");
export const loadConversationSuccess = createAction(actionScope + "LOAD_CONVERSATION_SUCCESS");

export const setBotAssessmentStateRequest = createAction(
  actionScope + "SET_BOT_ASSESSMENT_STATE_REQUEST",
);
export const setBotAssessmentStateSuccess = createAction(
  actionScope + "SET_BOT_ASSESSMENT_STATE_SUCCESS",
);

export const setRerunConversationIdRequest = createAction(
  actionScope + "SET_RERUN_CONVERSATION_ID_REQUEST",
);
export const setRerunConversationIdSuccess = createAction(
  actionScope + "SET_RERUN_CONVERSATION_ID_SUCCESS",
);
export const updateConversationFeedbackSuccess = createAction(
  actionScope + "UPDATE_CONVERSATION_FEEDBACK_SUCCESS",
);

// selectors
export const analyticsStartDateSelector = state => state.botpressSession.analyticsStartDate;
export const analyticsSelector = state => state.botpressSession.analytics;

export const botpressBotODMSelector = state => state.botpressSession.botpressBotODM;

export const chatPagesSelector = state => state.botpressSession.chatPages;
export const chatPaginationSelector = state => state.botpressSession.chatPagination;
export const chatPageLoadingSelector = state => state.botpressSession.chatPageLoading;
export const chatStartDateSelector = state => state.botpressSession.chatStartDate;
export const chatEndDatesSelector = state => state.botpressSession.chatEndDate;

export const flaggedChatPagesSelector = state => state.botpressSession.flaggedChatPages;
export const flaggedChatPaginationSelector = state => state.botpressSession.flaggedChatPagination;
export const flaggedChatPageLoadingSelector = state => state.botpressSession.flaggedChatPageLoading;

export const feedbackPagesSelector = state => state.botpressSession.feedbackPages;
export const feedbackPaginationSelector = state => state.botpressSession.feedbackPagination;

export const assessmentPagesSelector = state => state.botpressSession.assessmentPages;
export const assessmentPaginationSelector = state => state.botpressSession.assessmentPagination;

export const productsSelector = state => state.botpressSession.products;
export const productPagesSelector = state => state.botpressSession.productPages;
export const productPaginationSelector = state => state.botpressSession.productPagination;

export const conversationIdSelector = state => state.botpressSession.conversationId;
export const conversationFeedbackSelector = state => state.botpressSession.conversationFeedback;

const getDefaultPagination = () => {
  let newPage = createOmniPaginationObject(null, 20);
  newPage.pageIndex = 0;
  newPage.sort = { createdAt: "desc" };
  return newPage;
};

// initial state
const initialState = {
  analyticsBotODM: null,

  botpressBotODM: null,

  botStatus: null,
  botpressSummary: null,

  analytics: null,
  analyticsStartDate: new Date(helperGetIsoDate(29, true, true)), //30 days ago
  analyticsLoading: false,

  configurations: [],

  chats: [],
  chatPages: {},
  chatPagination: getDefaultPagination(null, 10),
  chatPageLoading: false,
  chatStartDate: new Date(helperGetIsoDate(29, true, true)), //30 days ago
  chatEndDate: new Date(helperGetIsoDate(0, false, true)), //today

  flaggedChats: [],
  flaggedChatPages: {},
  flaggedChatPagination: getDefaultPagination(null, 10),
  flaggedChatPageLoading: false,

  chatsAnalysis: null,
  chatsAnalysisLoading: false,

  feedback: [],
  feedbackPages: {},
  feedbackPagination: getDefaultPagination(null, 10),
  feedbackPageLoading: false,
  feedbacksStartDate: new Date(helperGetIsoDate(6, true, true)), //30 days ago
  feedbacksEndDate: new Date(helperGetIsoDate(0, false, true)), //today

  assessment: [],
  assessmentPages: {},
  assessmentPagination: getDefaultPagination(null, 10),
  assessmentPageLoading: false,
  assessmentsStartDate: new Date(helperGetIsoDate(6, true, true)), //7 days ago
  assessmentsEndDate: new Date(helperGetIsoDate(0, false, true)), //today

  products: [],
  productPages: {},
  productPagination: getDefaultPagination(null, 10),
  productPageLoading: false,

  conversationId: null,
  conversation: null,
  conversationFeedback: null,

  assessmentConversationId: null,
  assessmentUserKey: null,

  rerunConversationId: null,
  rerunConversationNumber: null,
  rerunFeedbackNumber: null,
};

// reducers
export default handleActions(
  {
    [botpressSessionRequestFailed]: state => state,

    [setAnalyticsBotODMRequest]: state => state,
    [setAnalyticsBotODMSuccess]: (state, { payload }) => ({
      ...state,
      analyticsBotODM: payload,
    }),

    [setBotpressBotODMRequest]: state => ({
      ...state,
      botpressBotODM: null,
    }),
    [setBotpressBotODMSuccess]: (state, { payload }) => ({
      ...state,
      botpressBotODM: payload,
    }),

    [loadAnalyticsRequest]: state => ({
      ...state,
      analyticsLoading: true,
    }),
    [loadAnalyticsSuccess]: (state, { payload }) => ({
      ...state,
      analytics: payload.analytics,
      analyticsStartDate: payload.analyticsStartDate,
      analyticsLoading: false,
    }),

    [loadConfigurationsRequest]: state => ({
      ...state,
      configurations: [],
    }),
    [loadConfigurationsSuccess]: (state, { payload }) => ({
      ...state,
      configurations: payload,
    }),

    [loadBotRequest]: state => state,
    [loadBotSuccess]: (state, { payload }) => ({
      ...state,
      botStatus: payload,
    }),

    [loadBotpressSummaryRequest]: state => state,
    [loadBotpressSummarySuccess]: (state, { payload }) => ({
      ...state,
      botpressSummary: payload,
    }),

    [deleteChatRequest]: state => state,
    [deleteChatSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [updateChatRequest]: state => state,
    [updateChatSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [searchChatsRequest]: state => ({
      ...state,
      chatPageLoading: true,
    }),
    [searchChatsSuccess]: (state, { payload }) => ({
      ...state,
      chats: payload.chats,
      chatPages: payload.chatPages,
      chatPagination: payload.chatPagination,
      chatPageLoading: false,
    }),

    [setSearchChatsDatesRequest]: state => state,
    [setSearchChatsDatesSuccess]: (state, { payload }) => ({
      ...state,
      chatStartDate: payload.chatStartDate,
      chatEndDate: payload.chatEndDate,
    }),

    [analyzeChatsRequest]: state => ({
      ...state,
      chatsAnalysisLoading: true,
    }),
    [analyzeChatsSuccess]: (state, { payload }) => ({
      ...state,
      chatsAnalysis: payload,
      chatsAnalysisLoading: false,
    }),

    [searchFlaggedChatsRequest]: state => ({
      ...state,
      flaggedChatPageLoading: true,
    }),
    [searchFlaggedChatsSuccess]: (state, { payload }) => ({
      ...state,
      flaggedChats: payload.flaggedChats,
      flaggedChatPages: payload.flaggedChatPages,
      flaggedChatPagination: payload.flaggedChatPagination,
      flaggedChatPageLoading: false,
    }),

    [searchFeedbackRequest]: state => ({
      ...state,
      feedbackPageLoading: true,
    }),
    [searchFeedbackSuccess]: (state, { payload }) => ({
      ...state,
      feedback: payload.feedback,
      feedbackPages: payload.feedbackPages,
      feedbackPagination: payload.feedbackPagination,
      feedbackPageLoading: false,
    }),

    [updateFeedbackRequest]: state => state,
    [updateFeedbackSuccess]: state => ({
      ...state,
    }),

    [deleteFeedbackRequest]: state => state,
    [deleteFeedbackSuccess]: state => ({
      ...state,
    }),

    [searchAssessmentRequest]: state => ({
      ...state,
      assessmentPageLoading: true,
    }),
    [searchAssessmentSuccess]: (state, { payload }) => ({
      ...state,
      assessment: payload.assessment,
      assessmentPages: payload.assessmentPages,
      assessmentPagination: payload.assessmentPagination,
      assessmentPageLoading: false,
    }),

    [updateAssessmentRequest]: state => state,
    [updateAssessmentSuccess]: state => ({
      ...state,
    }),

    [deleteAssessmentsRequest]: state => state,
    [deleteAssessmentsSuccess]: state => ({
      ...state,
    }),

    [searchProductsRequest]: state => ({
      ...state,
      productPageLoading: true,
    }),
    [searchProductsSuccess]: (state, { payload }) => ({
      ...state,
      products: payload.products,
      productPages: payload.productPages,
      productPagination: payload.productPagination,
      productPageLoading: false,
    }),

    [updateProductRequest]: state => state,
    [updateProductSuccess]: state => ({
      ...state,
    }),

    [deleteProductsRequest]: state => state,
    [deleteProductsSuccess]: state => ({
      ...state,
    }),

    [loadConversationRequest]: state => state,
    [loadConversationSuccess]: (state, { payload }) => ({
      ...state,
      conversationId: payload.conversationId,
      conversation: payload.conversation,
      conversationFeedback: payload.conversationFeedback,
    }),

    [setBotAssessmentStateRequest]: state => state,
    [setBotAssessmentStateSuccess]: (state, { payload }) => ({
      ...state,
      assessmentConversationId: payload.conversationId,
      assessmentUserKey: payload.userKey,
    }),

    [setRerunConversationIdRequest]: state => state,
    [setRerunConversationIdSuccess]: (state, { payload }) => ({
      ...state,
      rerunConversationId: payload?.rerunConversationId || null,
      rerunConversationNumber: payload?.rerunConversationNumber || null,
      rerunFeedbackNumber: payload?.rerunFeedbackNumber || null,
    }),
    [updateConversationFeedbackSuccess]: (state, { payload }) => ({
      ...state,
      conversationFeedback: payload,
    }),
  },
  initialState,
);
